import SchedulePage from './Page'

export default function Schedule() {
  return <SchedulePage />
}
